import { VehicleMedia } from "@alba-cars/common-modules";

import { formatImageUrl } from "@/lib/utils";

type AnyMedia = any;
type VideoRole = "main_horizontal" | "main_vertical";

export interface ResolvedVideo {
  src: string;
}

function resolveVideoSrc(media: AnyMedia): string {
  if (media.sourceType === "s3_key") {
    return (formatImageUrl(media.mediaUrl) as string) ?? media.mediaUrl;
  }
  return media.mediaUrl;
}

function extractVideoByRole(media: VehicleMedia[], role: VideoRole): ResolvedVideo | null {
  const video = (media as AnyMedia[]).find((m) => m.mediaType === "video" && m.videoRole === role) ?? null;
  if (!video) return null;
  return { src: resolveVideoSrc(video) };
}

export function extractHorizontalVideo(media: VehicleMedia[]): ResolvedVideo | null {
  // Temporarily disabled — photos carousel only
  // return extractVideoByRole(media, "main_horizontal");
  if (false) return extractVideoByRole(media, "main_horizontal");
  return null;
}

export function extractVerticalVideo(media: VehicleMedia[]): ResolvedVideo | null {
  // Temporarily disabled — photos carousel only
  // return extractVideoByRole(media, "main_vertical");
  if (false) return extractVideoByRole(media, "main_vertical");
  return null;
}

export function extractVideo(media: VehicleMedia[]): ResolvedVideo | null {
  // Temporarily disabled — photos carousel only
  // return extractHorizontalVideo(media);
  if (false) return extractHorizontalVideo(media);
  return null;
}

export function getImageMedia(media: VehicleMedia[]): VehicleMedia[] {
  return (media as AnyMedia[]).filter((m) => !m.mediaType || m.mediaType === "image") as VehicleMedia[];
}
